import { Divider } from "react-native-paper";
import { FlatCard } from "../Cards/FlatCard";
import HeaderCard from "../HeaderCard";

type Props = {
	children: React.ReactNode;
	title: string;
	subtitle: string;
	icon: string;
	actions?: React.ReactNode;
	onPress?: () => void;
	tooltip?: string;
	handleClickInfo?: (text: string) => void;
};
const CardContainer = ({
	children,
	title,
	subtitle,
	icon,
	actions,
	onPress,
	tooltip,
	handleClickInfo,
}: Props) => {
	return (
		<FlatCard onPress={onPress}>
			<HeaderCard
				tooltip={tooltip}
				handleClickInfo={handleClickInfo}
				title={title}
				subtitle={subtitle}
				icon={icon}
			/>
			<Divider />
			{children}
			{actions}
		</FlatCard>
	);
};

export default CardContainer;
